import { h } from "preact";
import { Table } from "antd";
import MembersDataSource from "./MembersDataSource";


export default function MembersListSection(props) {

    const { columns, rows } = MembersDataSource(props.data).asTableView(props);

    return <Table columns={columns} dataSource={rows} pagination={false} showHeader={true} />;
}